import React from 'react';
import { FileText, FileArchive } from 'lucide-react';
import SuggestedActions from './SuggestedActions';

const MessageItem = ({ message, onSuggestedActionClick }) => {
  const isUser = message.sender === 'user';
  
  // Helper function to get appropriate file icon
  const getFileIcon = (fileName) => {
    const extension = fileName.split('.').pop().toLowerCase();
    const documentTypes = ['pdf', 'doc', 'docx', 'txt', 'rtf', 'odt'];
    const imageTypes = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg'];
    
    if (documentTypes.includes(extension)) {
      return <FileText size={18} className={isUser ? "text-white" : "text-gray-600"} />;
    }
    
    return <FileArchive size={18} className={isUser ? "text-white" : "text-gray-600"} />;
  };
  
  return (
    <div className="mb-4">
      <div className={`flex ${isUser ? 'justify-end' : 'justify-start'}`}>
        <div 
          className={`p-[10px_18px] rounded-[18px] max-w-[80%] ${
            isUser 
              ? 'bg-primary text-white self-end' 
              : 'bg-[#f5f7fa] text-[#333] self-start'
          }`}
        >
          {/* Single file upload */}
          {message.type === 'file' && (
            <div className="flex items-center space-x-2">
              {getFileIcon(message.fileName)}
              <span className={`text-sm ${isUser ? 'text-white' : 'text-gray-800'}`}>
                {message.fileName}
              </span>
            </div>
          )}
          
          {/* Multiple files upload */}
          {message.type === 'files' && (
            <div className="flex flex-col">
              <div className="flex items-center space-x-2 mb-1">
                <FileArchive size={18} className={isUser ? "text-white" : "text-gray-600"} />
                <span className={`text-sm font-medium ${isUser ? 'text-white' : 'text-gray-800'}`}>
                  {message.fileCount > 1 
                    ? `Uploaded ${message.fileCount} files` 
                    : `Uploaded file`}
                </span>
              </div>
              <div className={`text-xs ${isUser ? 'text-white/80' : 'text-gray-600'} ml-6`}>
                {message.fileNames}
              </div>
            </div>
          )}
          
          {/* Iframe content */}
          {message.type === 'iframe' && (
            <iframe
              src={message.url}
              title="Content"
              className="w-full h-[300px] border-0 rounded"
              allowFullScreen
            />
          )}
          
          {/* Regular text message */}
          {!message.type && (
            <div 
              className={`text-sm ${isUser ? 'text-white' : 'text-gray-800'}`}
              dangerouslySetInnerHTML={{ __html: message.text }}
            />
          )}
          
          {/* Show query if present */}
          {message.query && (
            <div className="mt-2 pt-2 border-t border-gray-200 text-xs text-gray-500">
              <p>Query: {message.query}</p>
            </div>
          )}
        </div>
      </div>
      
      {/* Suggested actions - only show for bot messages */}
      {!isUser && message.suggested_actions && message.suggested_actions.length > 0 && (
        <div className="mt-2 ml-2">
          <SuggestedActions 
            actions={message.suggested_actions} 
            onActionClick={onSuggestedActionClick} 
          />
        </div>
      )}
    </div>
  );
};

export default MessageItem;